/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type CreateGcpIamCredentialForm = {
  /**
   * The service account in your project that Speakeasy impersonates. Grant Speakeasy's own service account roles/iam.serviceAccountTokenCreator on it — see externalCredentials.getGcpSetupInfo.
   */
  impersonateServiceAccount: string;
  /**
   * A human-readable name for the credential.
   */
  name: string;
};

/** @internal */
export type CreateGcpIamCredentialForm$Outbound = {
  impersonate_service_account: string;
  name: string;
};

/** @internal */
export const CreateGcpIamCredentialForm$outboundSchema: z.ZodMiniType<
  CreateGcpIamCredentialForm$Outbound,
  CreateGcpIamCredentialForm
> = z.pipe(
  z.object({
    impersonateServiceAccount: z.string(),
    name: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      impersonateServiceAccount: "impersonate_service_account",
    });
  }),
);

export function createGcpIamCredentialFormToJSON(
  createGcpIamCredentialForm: CreateGcpIamCredentialForm,
): string {
  return JSON.stringify(
    CreateGcpIamCredentialForm$outboundSchema.parse(createGcpIamCredentialForm),
  );
}
